import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pb-2" }
const _hoisted_2 = { class: "text-caption font-weight-bold mt-2 text-grey-darken-1" }
const _hoisted_3 = { class: "text-caption font-weight-bold mt-2 text-grey-darken-1" }
const _hoisted_4 = { class: "text-caption font-weight-bold mt-2 text-grey-darken-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.open,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
      "max-width": "720px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('mailbox.detail')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.chat)
                  ? (_openBlock(), _createBlock(_component_v_table, {
                      key: 0,
                      class: "pt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('common.date')), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.chat.date)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('mailbox.recipients')), 1),
                            _createElementVNode("td", _hoisted_1, [
                              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.class')), 1),
                              _createElementVNode("div", null, _toDisplayString((_ctx.chat.to.groups.length == 0 && _ctx.chat.to.children.length == 0) ? _ctx.getClassNames(_ctx.chat.to.classes) : ''), 1),
                              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('mailbox.group')), 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.getGroupNames(_ctx.chat.to.groups)), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('mailbox.title')), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.title), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('mailbox.body')), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.body), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('mailbox.unreadCount')), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.chatUnReadCount) + _toDisplayString(_ctx.$t('mailbox.people')), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('mailbox.readCount')), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.chat.chatReadCount) + _toDisplayString(_ctx.$t('mailbox.people')), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('mailbox.readBy')), 1),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedReadClassChildren, (item, i) => {
                                return (_openBlock(), _createElementBlock("div", { key: i }, [
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(String(item.year)) + _toDisplayString(_ctx.$t('mailbox.schoolYear')) + " " + _toDisplayString(item.className), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: child.childId
                                    }, _toDisplayString(child.lastName + ' ' + child.firstName), 1))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t('mailbox.attachment')), 1),
                            _createElementVNode("td", null, [
                              (_ctx.chat.attachmentUrls?.length > 0)
                                ? (_openBlock(), _createBlock(_component_v_img, {
                                    key: 0,
                                    src: _ctx.chat.attachmentUrls[0]
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat.attachmentUrls, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      cols: "12",
                                      key: i,
                                      class: "py-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          href: item,
                                          target: "_blank",
                                          color: "primary",
                                          variant: "outlined",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('mailbox.attachment')) + _toDisplayString(i+1), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["href"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.close,
                          color: "grey",
                          variant: "text"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common_actions.close')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_spacer),
                        (_ctx.isDraft)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _ctx.editMessage,
                              color: "primary",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common_actions.edit')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}